<template>
    <div class="c-policy">
        <h2>
            Disclaimer
        </h2>

        <p>
            BC Legal’s ABC Quantum software is provided 'as is' without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability, suitability for a particular purpose, or non-infringement.
        </p>

        <p>
            Without limiting the foregoing, BC Legal makes no warranty that:
        </p>

        <ul>
            <li>the software will meet your requirements</li>
            <li>the software will be uninterrupted, timely, secure or error-free</li>
            <li>the results that may be obtained from the use of the software will be effective, accurate or reliable</li>
            <li>the quality of the software will meet your expectations</li>
            <li>any errors in the software obtained will be corrected</li>
        </ul>

        <p>
            In no event shall BC Legal be liable to you or any third parties for any special, punitive, incidental, indirect or consequential damages of any kind, or any damages whatsoever, including, without limitation, those resulting from loss of use, data or profits, whether or not BC Legal has been advised of the possibility of such damages, and on any theory of liability, arising out of or in connection with the use of this software.
        </p>

        <p>
            The use of the software provided by BC Legal is done at your own discretion and risk and with the agreement that you will be solely responsible for any damage to your computer system or loss of data that results from such activities. No advice or information, whether oral or written, obtained by you from the BC Legal or from the BC Legal website or ABC Quantum software shall create any warranty for the software.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'disclaimer',
    }
</script>


// WEBPACK FOOTER //
// Disclaimer.vue?08198688